import { InfoOutlined } from '@mui/icons-material';
import { Alert, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { EmailTemplateStartCondition } from '../../../types/EmailTemplate';
import { offsetToText } from '../../../utility/dateUtils';
import { DependencyOption } from '../../tasks/StartCondition';
import { ModalState } from './AddEmailTemplateModal';

interface EmailTemplateSummaryProps {
  modalState: ModalState;
  dependencyOptions: DependencyOption[];
}

export default function EmailTemplateSummary({ modalState, dependencyOptions }: EmailTemplateSummaryProps) {
  const { email_template_name, roles_values, start_condition, offset, depends_on_uuid } = modalState;

  if (!email_template_name) return null;

  const roleText = roles_values?.join(', ') || '(no role selected)';
  const recipientClause = <>to the contact(s) with role: <strong>{roleText}</strong></>;

  let body: React.ReactNode;

  switch (start_condition) {
    case EmailTemplateStartCondition.MANUAL:
      body = <>will be sent {recipientClause} when triggered manually.</>;
      break;
    case EmailTemplateStartCondition.DATE_OFFSET:
      body = <>will be sent {offset !== null && <strong>{offsetToText(offset)}</strong>} {recipientClause}.</>;
      break;
    case EmailTemplateStartCondition.EVENT_DEPENDENCY:
      body = <>will be sent after this event is completed {recipientClause}.</>;
      break;
    case EmailTemplateStartCondition.TASK_DEPENDENCY: {
      const dep = _.find(dependencyOptions, { uuid: depends_on_uuid || '' });
      body = dep
        ? <>will be sent after <strong>{dep.name}</strong> is completed {recipientClause}.</>
        : <>will be sent after a task is completed {recipientClause}.</>;
      break;
    }
  }

  return (
    <Alert icon={<InfoOutlined fontSize="small" color="info" />} sx={{ bgcolor: 'grey.100', color: 'text.secondary', boxShadow: 'none', alignItems: 'center' }}>
      <Typography variant="body2">
        <strong>{email_template_name}</strong> {body}
      </Typography>
    </Alert>
  );
}
